// -----------------------------------------------------------------------------
// Home
// -----------------------------------------------------------------------------

import * as videoUtility from '../utility/videoUtility';

const init = () => {
  if ($('.js-body').hasClass('js-body-home') === false) {
    return;
  }

  initAJAX();
  initEventListeners();
  inMatchingServices();
};

/**
 * AJAX einrichten
 */
const initAJAX = () => {
  // Success-Storys
  initAJAXsuccessStory();

  // Videos
  initAJAXvideos();
};

/**
 * Matching Services - Auto adjust Height
 */
const inMatchingServices = () => {
  $(window).on('resize load scroll', function () {
    // Function to equalize the height of elements
    function equalHeight(group) {
      group.height('auto'); // Reset the height
      var tallest = 0;
      group.each(function () {
        var thisHeight = $(this).height();
        if (thisHeight > tallest) {
          tallest = thisHeight;
        }
      });
      group.height(tallest);
    }

    // Apply uniform height to the titles
    equalHeight($('.fit_title'));
    // Apply uniform height to the texts
    equalHeight($('.fit_text'));
    // Apply uniform height inner parts
    equalHeight($('.fit_in1'));
  });
};

/**
 * Success-Story-Artikel laden
 */
const initAJAXsuccessStory = () => {
  const $body = $('.js-body');
  const basepath = $body.attr('data-basepath');
  const $container = $('.js-app-success-stories-article-home');
  const count = parseInt($container.attr('data-count-' + getViewport()), 10);
  const trans = JSON.parse(document.querySelector('.js-app-success-stories-article-home #trans').textContent);

  $.get(`${basepath}/success_story/home?type=article&count=${count}`, (data) => {
    $container.attr('data-page', data.page);
    $container.attr('data-total', data.total);
    $container.find('.js-success-stories').html(data.html);
  })
    .fail(function () {
      $container.html(trans.error);
    });
};

/**
 * Success-Story-Videos laden
 */
const initAJAXvideos = () => {
  const $body = $('.js-body');
  const basepath = $body.attr('data-basepath');
  const $container = $('.js-app-success-stories-video-home');
  const count = parseInt($container.attr('data-count-' + getViewport()), 10);
  const trans = JSON.parse(document.querySelector('.js-app-success-stories-video-home #trans').textContent);

  $.get(`${basepath}/success_story/home?type=video&count=${count}`, (data) => {
    $container.attr('data-page', data.page);
    $container.attr('data-total', data.total);
    $container.find('.js-success-stories').html(data.html);

    // Video-Bereich ausblenden, falls keine Videos vorhanden sind
    if (data.total === 0) {
      $container.parents('#successstories-video').hide();
    }

    // Video-Vorschaubilder zeigen
    $container.find('.js-lazy-load-video').each(function () {
      const div = videoUtility.initVideo(this.dataset.id);
      $(this).append(div);
    });
  })
    .fail(function () {
      $container.html(trans.error);
    });
};

/**
 * Liefert zurück, ob Desktop- oder Mobile-Version vorliegt
 *
 * @returns {string}
 */
const getViewport = () => {
  return ($('.js-body').hasClass('js-desktop')) ? 'desktop' : 'mobile';
};

/**
 * Event-Listeners einrichten
 */
const initEventListeners = () => {
  const $container = $('.js-app-success-stories-article-home');

  $container.click((event) => {
    if (event.target.classList) {
      for (let i = 0; i < event.target.classList.length; i++) {
        const $targetElement = $(event.target).parent();

        // Abbruch, falls Element nicht aktiv ist
        if ($targetElement.prop('disabled')) {
          continue;
        }

        // Buttons
        if ($targetElement.hasClass('js-success-stories-button')) {
          event.preventDefault();

          loadArticles($targetElement);
          break;
        }
      }
    }
  });
};


/**
 * Artikel nachladen
 *
 * @param $elem
 */
const loadArticles = ($elem) => {
  const $body = $('.js-body');
  const basepath = $body.attr('data-basepath');
  const $container = $('.js-app-success-stories-article-home');
  const page = parseInt($container.attr('data-page'), 10);
  const total = parseInt($container.attr('data-total'), 10);
  const count = parseInt($container.attr('data-count-' + getViewport()), 10);
  const dir = $elem.attr('data-dir');
  const trans = JSON.parse(document.querySelector('.js-app-success-stories-article-home #trans').textContent);

  let newPage;
  const totalPages = Math.ceil(total / count);

  if (dir === 'next') {
    newPage = ((page + 1) <= totalPages) ? page + 1 : 1;
  }

  if (dir === 'prev') {
    newPage = ((page - 1) > 0) ? page - 1 : totalPages;
  }

  $.get(`${basepath}/success_story/home?type=article&page=${newPage}&count=${count}`, (data) => {
    $container.attr('data-page', data.page);
    $container.find('.js-success-stories').html(data.html);
  })
    .fail(function () {
      $container.html(trans.error);
    });
};

export {
  init
};
